import Rule from '@/engine/rules/rule'
import GameState from '@/engine/models/game-state'
import TurnState from '@/engine/models/turn-state'
import audioService from '@/services/audio-service'

export default class VictoryRule implements Rule {

    public satisfied(turnState: TurnState, state: GameState): boolean {
        return state.numActiveTeams === 1
    }

    public action(turnState: TurnState, state: GameState): GameState {
        audioService.playVictory()
        state.state = 'game-over'
        return state
    }
}
